import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_coupon_line_RowClass} from '../../../dbschema/bl_fi_mst_coupon_line';

export class CouponLineContainerModel extends BaseContainerModel {
  // bl_fi_mst_coupon_line: bl_fi_mst_coupon_line_RowClass = new bl_fi_mst_coupon_line_RowClass();
  bl_fi_mst_coupon_line: bl_fi_mst_coupon_line_RowClass = new bl_fi_mst_coupon_line_RowClass();
}
